import { render, staticRenderFns } from "./SelectorTypeAcceptance.vue?vue&type=template&id=0f6ea588&"
import script from "./SelectorTypeAcceptance.vue?vue&type=script&lang=ts&"
export * from "./SelectorTypeAcceptance.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorTypeAcceptance.vue?vue&type=style&index=0&id=0f6ea588&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports